import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import { LinkBox, LinkFrame } from './shared.js';
import { Montserrat } from '../../assets/fonts.js';

var _templateObject;
var NavRoot = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: #fff;\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 16px;\n  width: 100%;\n  flex-grow: 45;\n  position: relative;\n"])), Montserrat);
var Subnav = (function (_ref) {
  var option = _ref.option,
    comp = _ref.comp;
  var to = option.to,
    label = option.label,
    target = option.target,
    root = option.root,
    options = option.options;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(NavRoot, {
    key: to,
    target: target,
    className: "".concat(root && "active", " pga-nav")
  }, label), /*#__PURE__*/React__default.createElement("div", null, options.map(function (option) {
    var to = option.to,
      label = option.label,
      target = option.target,
      external = option.external;
    var CollapseComp = comp && !external ? comp : LinkFrame;
    return /*#__PURE__*/React__default.createElement(LinkBox, {
      key: label
    }, /*#__PURE__*/React__default.createElement("i", {
      className: "fa fa-angle-right m-2 text-white"
    }), /*#__PURE__*/React__default.createElement(CollapseComp, {
      exact: true,
      to: to,
      target: target,
      external: external,
      className: "pga-nav"
    }, option.label));
  })));
});

export { Subnav as default };
